<template>
    <div class="card directory-list-card">
        <div class="card-header directory-list-card__header">
            <div class="directory-list-card__title">
                <h4>{{ $t('Company Directory') }}</h4>
            </div>
            <div class="directory-list-card__actions">
                <button class="btn btn-primary directory-add-btn" data-bs-toggle="modal" data-bs-target="#CreateCompanyModal" @click="OpenCompanyModal"><i class="fa-solid fa-plus"></i> {{ $t('Add Company') }}</button>
            </div>
        </div>
        <div class="card-body directory-list-card__body">
            <div class="directory-list-toolbar">
                <div class="directory-search">
                    <i class="fa-solid fa-magnifying-glass"></i>
                    <input type="text" class="form-control" :placeholder="$t('Search Company')" @keyup="SearchCompany" v-model="searchParams.search" />
                </div>
                <div class="directory-pagination" v-if="companyList.totalDocs">
                    <Pagination
                        :paginationDetails="{totalPages : companyList.totalPages, page : companyList.page}"
                        :changePage="ChangePage" 
                    ></Pagination>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-striped directory-table">
                    <thead>
                        <tr>
                            <th>{{ $t('Company Name') }}</th>
                            <th>{{ $t('Email') }}</th>
                            <th>{{ $t('Phone') }}</th>
                            <th>{{ $t('Type') }}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody v-if="!isLoaded">
                        <tr>
                            <td colspan="5" class="text-center directory-empty-state">
                                <Loader />
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else-if="companyList.docs.length==0">
                        <tr>
                            <td colspan="5" class="text-center directory-empty-state">
                                {{ $t('No Data Found') }}
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr v-for="(item, key) in companyList.docs" :key="item._id || key" :class="{ 'is-highlighted': item._id === highlightedCompanyId }">
                            <td class="directory-user-name">{{item.companyName}}</td>
                            <td>{{item.email}}</td>
                            <td>{{item.phone}}</td>
                            <td>{{GetCompanyTypeDisplayName(item.companyType)}}</td>
                            <td class="directory-table__actions">
                                <button data-bs-toggle="modal" data-bs-target="#EditCompanyModal" @click="OpenUpdateCompanyModal(item)" class="directory-icon-btn directory-icon-btn--edit" :title="$t('Edit')"><i class="fa-solid fa-pen"></i></button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <Modal idModal="CreateCompanyModal" :headerTitle="$t('Create Company')">
        <div class="user-modal-form">
        <div class="form-group">
            <label :class="{ 'required-style': !newCompanyData.companyName }">{{ $t('Company Name') }} </label>
            <input type="text" class="form-control" :placeholder="$t('Company Name')" v-model="newCompanyData.companyName" />
            <small class="text-warning" v-if="isAddNewClicked&&!newCompanyData.companyName">{{ $t('Required') }}</small>
        </div>
        <div class="form-group">
            <label :class="{ 'required-style': !newCompanyData.officeId }">{{ $t('Office') }} </label>
            <select class="form-select text-capitalize" v-model="newCompanyData.officeId">
                <option value="">{{ $t('Please Select') }} </option>
                <template v-for="(item, key) in officeList" :key="key">
                    <option :value="item._id">{{item.officeName}}</option>
                </template>
            </select>
            <small class="text-warning" v-if="isAddNewClicked&&!newCompanyData.officeId">{{ $t('Required') }}</small>
        </div>
        <div class="form-group">
            <label :class="{ 'required-style': !newCompanyData.companyType }">{{ $t('Type') }} </label>
            <select class="form-select" v-model="newCompanyData.companyType">
                <option value="">{{ $t('Please Select') }} </option>
                <template v-for="(item, key) in CompanyTypeList" :key="key">
                    <option :value="item.id">{{ $t(item.value) }}</option>
                </template>
            </select>
            <small class="text-warning" v-if="isAddNewClicked&&!newCompanyData.companyType">{{ $t('Required') }}</small>
        </div>
        <div class="form-group" v-if="newCompanyData.companyType==CompanyType.VENDOR">
            <label >{{ $t('Main Trade') }}</label>
            <select class="form-select" v-model="newCompanyData.mainTrade">
                <option value="">{{ $t('Please Select') }} </option>
                <template v-for="(item, key) in companyTypesData" :key="key">
                    <option :value="item._id">{{item.companyTypeName}}</option>
                </template>
            </select>
        </div>
        <div class="form-group">
            <label :class="{ 'required-style': !newCompanyData.address }">{{ $t('Company Address') }}</label>
            <textarea class="form-control" v-model="newCompanyData.address" :placeholder="$t('Company Address')"></textarea>
            <small class="text-warning" v-if="isAddNewClicked&&!newCompanyData.address">{{ $t('Required') }}</small>
        </div>
        <div class="d-flex justify-content-end" >
            <small class="float-end text-primary" role="button" @click="()=>{ ShowDetails =!ShowDetails }">{{ ShowDetails ?  $t('Hide') : $t('Show')}} {{ $t('Additional Details') }}</small>
        </div>
        <template v-if="ShowDetails">
            <div class="form-group">
                <label >{{ $t('Website') }}</label>
                <input type="text" class="form-control" :placeholder="$t('Company Website')" v-model="newCompanyData.companyWebsite" />
            </div>
            <div class="form-group">
                <label >{{ $t('Email') }}</label>
                <input type="text" class="form-control" :placeholder="$t('Company Email')" v-model="newCompanyData.email" />
            </div>
            <div class="form-group">
                <label >{{ $t('Phone') }}</label>
                <input type="text" class="form-control" :placeholder="$t('Company Phone')" v-model="newCompanyData.phone" />
            </div>
            <div class="form-group">
                <label >{{ $t('Fax') }}</label>
                <input type="text" class="form-control" :placeholder="$t('Company Fax')" v-model="newCompanyData.fax" />
            </div>
        </template>
        </div>
        <template v-slot:actions>
            <button type="button" ref="closeAddModal" class="btn user-modal-btn user-modal-btn--cancel" data-bs-dismiss="modal">{{ $t('Cancel') }}</button>
            <button class="btn user-modal-btn user-modal-btn--submit" @click="CreateCompany" :disabled="isSaving" >{{ $t('CREATE') }}</button>
        </template>
    </Modal>
    <Modal idModal="EditCompanyModal" :headerTitle="$t('Edit Company')">
        <div class="user-modal-form">
        <div class="form-group">
            <label :class="{ 'required-style': !updateCompanyData.companyName }">{{ $t('Company Name') }} </label>
            <input type="text" class="form-control" :placeholder="$t('Company Name')" v-model="updateCompanyData.companyName" />
            <small class="text-warning" v-if="isUpdateClicked&&!updateCompanyData.companyName">{{ $t('Required') }}</small>
        </div>
        <div class="form-group">
            <label :class="{ 'required-style': !updateCompanyData.officeId }">{{ $t('Office') }} </label>
            <select class="form-select text-capitalize" v-model="updateCompanyData.officeId">
                <option value="">{{ $t('Please Select') }} </option>
                <template v-for="(item, key) in officeList" :key="key">
                    <option :value="item._id">{{item.officeName}}</option>
                </template>
            </select>
            <small class="text-warning" v-if="isUpdateClicked&&!updateCompanyData.officeId">{{ $t('Required') }}</small>
        </div>
        <div class="form-group">
            <label :class="{ 'required-style': !updateCompanyData.companyType }">{{ $t('Type') }} </label>
            <select class="form-select" v-model="updateCompanyData.companyType">
                <option value="">{{ $t('Please Select') }} </option>
                <template v-for="(item, key) in CompanyTypeList" :key="key">
                    <option :value="item.id">{{ $t(item.value) }}</option>
                </template>
            </select>
            <small class="text-warning" v-if="isUpdateClicked&&!updateCompanyData.companyType">{{ $t('Required') }}</small>
        </div>
        <div class="form-group" v-if="updateCompanyData.companyType==CompanyType.VENDOR">
            <label >{{ $t('Main Trade') }}</label>
            <select class="form-select" v-model="updateCompanyData.mainTrade">
                <option value="">{{ $t('Please Select') }} </option>
                <template v-for="(item, key) in companyTypesData" :key="key">
                    <option :value="item._id">{{item.companyTypeName}}</option>
                </template>
            </select>
        </div>
        <div class="form-group">
            <label :class="{ 'required-style': !updateCompanyData.address }">{{ $t('Company Address') }}</label>
            <textarea class="form-control" v-model="updateCompanyData.address" :placeholder="$t('Company Address')"></textarea>
            <small class="text-warning" v-if="isUpdateClicked&&!updateCompanyData.address">{{ $t('Required') }}</small>
        </div>
        <div class="form-group">
            <label >{{ $t('Website') }}</label>
            <input type="text" class="form-control" :placeholder="$t('Company Website')" v-model="updateCompanyData.companyWebsite" />
        </div>
        <div class="form-group">
            <label>{{ $t('Email') }}</label>
            <input type="text" class="form-control" :placeholder="$t('Company Email')" v-model="updateCompanyData.email" />
        </div>
        <div class="form-group">
            <label >{{ $t('Phone') }}</label>
            <input type="text" class="form-control" :placeholder="$t('Company Phone')" v-model="updateCompanyData.phone" />
        </div>
        <div class="form-group">
            <label >{{ $t('Fax') }}</label>
            <input type="text" class="form-control" :placeholder="$t('Company Fax')" v-model="updateCompanyData.fax" />
        </div>
        </div>
        <template v-slot:actions>
            <button type="button" ref="closeUpdateModal" class="btn user-modal-btn user-modal-btn--cancel" data-bs-dismiss="modal">{{ $t('Cancel') }}</button>
            <button class="btn user-modal-btn user-modal-btn--submit" :disabled="isSaving" @click="UpdateCompany" >{{ $t('Save Changes') }}</button>
        </template>
    </Modal>
</template>

<script src="@/assets/directoryJs/Company.js" />
